import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useAppDispatch, useAppSelector } from "../store/hooks/hooks";
import { getUserDetailsAction } from "../store/StudentAction";
import ErrorHandler from "../utils/ErrorHandler/errorHandler";
import Loading from "../utils/loading/loading";
import MessageSnackbar from "../utils/snackBar/snackBar";
import AdminDashboard from "./adminDashboard/admin";
import './dashboard.scss'
import EmployerDashboard from "./employerDashboard/dashboard";
import Navbar from "./navbar/navbar";
import StudentDashboardContainer from "./studentDashboard/StudentDashboard";

const Dashboard = () => {
    const userDetails = useAppSelector((state: any) => state.user.user)
    const dispatch = useAppDispatch()
    const fetchUserDetails = async () => {
        await dispatch(getUserDetailsAction())
    }
    useEffect(() => {
        fetchUserDetails()
    }, [])

    return (
        <>
            <>
                <ErrorBoundary FallbackComponent={ErrorHandler}>
                    {
                        Object.keys(userDetails).length > 0 ? <div className="fadedown dashboardContainer">
                            {
                                userDetails.isAdmin ? <>
                                    <AdminDashboard></AdminDashboard>
                                </> : userDetails.isEmployer ? <>
                                    <EmployerDashboard></EmployerDashboard>
                                </> : <>
                                    <StudentDashboardContainer></StudentDashboardContainer>
                                </>
                            }

                        </div> :
                            <>
                                <Loading message="Placements"></Loading>
                            </>
                    }
                    <MessageSnackbar></MessageSnackbar>

                </ErrorBoundary>
            </>

        </>
    )

}
export default Dashboard